import { Button } from 'react-bootstrap'
import styled from 'styled-components'

const ActionButton = styled(Button)` 
  cursor: pointer;
  text-align: center;
  background-size: 300% 100%;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  &:hover {
    background-position: 100% 0;
    -o-transition: all 0.4s ease-in-out;
    -webkit-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
    background-image: linear-gradient(
      to right,
      #533355,
      #b847c0,
      #5a0e5f,
      #5a0e5f
    );
    box-shadow: 0 5px 15px rgba(242, 97, 103, 0.4);
  }
`
export default ActionButton
